import type { AxiosError } from 'axios';

export default class HTTPErrorResponseAdapter {
    static getErrorResponse(error: AxiosError) {
        if (error?.response?.data) return error.response.data;
        if (error?.response) return error.response;
        return error;
    }
}
